import { type ReactElement, type ReactNode, useCallback, useMemo, useState } from 'react';
import { SiteNoticeContext } from './site-notice-context';
import { noAccessSiteNotice, type SiteNotice, technicalIssuesSiteNotice } from '@/app/config/global';

interface SiteNoticeProviderProperties {
  readonly children: ReactNode;
}

export const SiteNoticeProvider = ({ children }: SiteNoticeProviderProperties): ReactElement => {
  const [siteNotices, setSiteNotices] = useState<readonly SiteNotice[]>([]);

  const showTechnicalIssuesNotice = useCallback(() => {
    setSiteNotices((currentSiteNotices) =>
      currentSiteNotices.some((siteNotice) => siteNotice.id === technicalIssuesSiteNotice.id)
        ? currentSiteNotices
        : [...currentSiteNotices, technicalIssuesSiteNotice],
    );
  }, []);

  const showNoAccessNotice = useCallback(() => {
    setSiteNotices((currentSiteNotices) =>
      currentSiteNotices.some((siteNotice) => siteNotice.id === noAccessSiteNotice.id)
        ? currentSiteNotices
        : [...currentSiteNotices, noAccessSiteNotice],
    );
  }, []);

  const contextValue = useMemo(
    () => ({
      siteNotices,
      showTechnicalIssuesNotice,
      showNoAccessNotice,
    }),
    [siteNotices, showTechnicalIssuesNotice, showNoAccessNotice],
  );

  return <SiteNoticeContext value={contextValue}>{children}</SiteNoticeContext>;
};
